export default __webpack_public_path__ + "static/media/046-farm.ad937475.svg";